<script setup lang="ts">
import { PropType, ref, onMounted } from 'vue'
import type { TravelInfoPod } from './../../types'
import { StatusColour } from './../../types/enums'
import { getCurrentCulture } from './../../utilities/culture-helper'

const props = defineProps({
  travelInfo: {
    type: Object as PropType<TravelInfoPod>,
    required: true,
  },
})

const statusThemeClass = ref<string>()
const statusThemeIcon = ref<string>()
const { cultureShortCode } = getCurrentCulture()

onMounted(() => {
  switch (props.travelInfo.statusColour) {
    default:
      break
    case StatusColour.Green:
      statusThemeIcon.value = '#svg-check'
      statusThemeClass.value = 'status-card--success'
      break
    case StatusColour.Amber:
      statusThemeIcon.value = '#svg-warning'
      statusThemeClass.value = 'status-card--warning'
      break
    case StatusColour.Red:
      statusThemeIcon.value = '#svg-alert'
      statusThemeClass.value = 'status-card--danger'
      break
  }
})
</script>

<template>
  <div v-if="travelInfo.isVisible" :class="['status-card', statusThemeClass]">
    <svg class="status-card__icon" aria-hidden="true">
      <use :xlink:href="statusThemeIcon"></use>
    </svg>
    <div v-if="travelInfo.title[cultureShortCode]" class="status-card__title">
      {{ travelInfo.title[cultureShortCode] }}
    </div>
    <div
      v-if="travelInfo.status[cultureShortCode]"
      class="status-card__content"
    >
      {{ travelInfo.status[cultureShortCode] }}
    </div>
    <div
      v-if="travelInfo.messages"
      v-for="msg in travelInfo.messages"
      class="status-card__message"
    >
      {{ msg[cultureShortCode] }}
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
